import styled from 'styled-components';

export const AudioContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px 5px 5px;
  border: 1px solid ${({ theme }) => theme.colorPalette.grey.grey3};
  border-radius: 999px;
  background: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.white : theme.colorPalette.grey.grey2};
  width: 320px;
  box-sizing: border-box;
  margin-bottom: 10px;
`;

export const PlayButton = styled.button<{ isPlaying: boolean }>`
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.colorPalette.turquoise.dark};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: ${({ theme }) => theme.colorPalette.turquoise.dark};
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: ${({ theme }) => theme.colorPalette.turquoise.dark};
    color: ${({ theme }) => theme.colorPalette.white};
  }

  svg {
    display: block;
  }
`;

export const TimeDisplay = styled.span`
  flex-shrink: 0;
  font-size: ${({ theme }) => theme.fontSizePalette.xSmall};
  color: ${({ theme }) => theme.colorPalette.grey.grey8};
  white-space: nowrap;
`;

export const SeekBar = styled.input<{ progress: number }>`
  -webkit-appearance: none;
  appearance: none;
  flex: 1;
  height: 3px;
  border-radius: 22px;
  outline: none;
  cursor: pointer;
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.colorPalette.grey.grey7} 0%,
    ${({ theme }) => theme.colorPalette.grey.grey7} ${({ progress }) => progress}%,
    ${({ theme }) => theme.colorPalette.grey.grey5} ${({ progress }) => progress}%,
    ${({ theme }) => theme.colorPalette.grey.grey5} 100%
  );

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colorPalette.grey.grey8};
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: none;
    background: ${({ theme }) => theme.colorPalette.grey.grey8};
    cursor: pointer;
  }
`;

export const IconButton = styled.button`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  color: ${({ theme }) => theme.colorPalette.grey.grey7};

  &:hover {
    color: ${({ theme }) => theme.colorPalette.grey.grey9};
  }
`;

export const OpenSourceButton = styled.a`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colorPalette.grey.grey6};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colorPalette.turquoise.accent2};
  }
`;
